import { useCallback } from 'react';
import { useAppDispatch } from 'store/hooks';
import { skippedPremiumBeforeChooseBank, skippedPremiumScreen, upgradedToPremium, } from '../../actions/signinNavigation';
import { useNavigateToNextScreen } from '../../hooks/useNavigateToNextScreen';
export const useNavigateToLoggedInFromPremium = () => {
    const navigateToNextScreen = useNavigateToNextScreen();
    const dispatch = useAppDispatch();
    return useCallback(({ skippingPremium, skippingPremiumBeforeChooseBank, }) => {
        if (skippingPremiumBeforeChooseBank) {
            dispatch(skippedPremiumBeforeChooseBank());
        }
        else if (skippingPremium) {
            dispatch(skippedPremiumScreen());
        }
        else {
            dispatch(upgradedToPremium());
        }
        navigateToNextScreen();
    }, [navigateToNextScreen]);
};
